import React from 'react';
import { useSpring, animated } from 'react-spring';
import styled, { css } from 'styled-components';
import ChevronDown from '../../common/Icons/Light/ChevronDown';
import { neutral } from '../../../style/colors';

const FilterHeader = (props: IFilterHeaderPropTypes) => {
  const { title, toggled, onClick, onIconClick, icon, iconToggled } = props;
  const upsideDown = useSpring({
    transform: toggled ? 'rotateX(180deg)' : 'rotateX(0)',
  });

  return (
    <Wrapper onClick={onClick} toggled={toggled}>
      <h1>{title}</h1>
      <Icon
        iconToggled={iconToggled}
        onClick={
          onIconClick
            ? e => {
              e.stopPropagation();
              onIconClick();
            }
            : () => { }
        }
      >
        {icon}
      </Icon>
      <animated.div
        style={{
          ...{
            height: 18,
            padding: '0 1.5em 0 1em',
          },
          ...upsideDown,
        }}
      >
        <ChevronDown width={16} />
      </animated.div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 65px;
  h1 {
    padding-left: 20px;
    font-size: 17px;
  }
  cursor: pointer;
  ${props =>
    !props.toggled &&
    css`
      border-bottom: 1px solid ${neutral[200]};
    `}
  :hover {
    background-color: ${neutral[150]};
  }
`;
const Icon = styled.div`
  margin-left: auto;
  border-radius: 100%;
  transition: background-color 0.3s;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${neutral[100]};  
  }
  ${props =>
    props.iconToggled &&
    css`
      background-color: #ffffff;
    `}
`;

interface IFilterHeaderPropTypes {
  title: string;
  toggled: boolean;
  iconToggled: boolean;
  onClick: Function;
  onIconClick?: Function;
  icon: any;
}

export default FilterHeader;
